import React, { FC, MouseEvent } from 'react';
import Icon from '@ant-design/icons';

export const CloseCircleFilled: FC<{
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}> = props => <Icon component={CloseCircleFilledSVG} {...props} />;

const CloseCircleFilledSVG = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      opacity='0.4'
      d='M7.99967 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 8.00004C14.6663 4.31814 11.6816 1.33337 7.99967 1.33337C4.31778 1.33337 1.33301 4.31814 1.33301 8.00004C1.33301 11.6819 4.31778 14.6667 7.99967 14.6667Z'
      fill='#A5B0CB'
    />
    <path
      d='M8.7069 7.99999L10.2402 6.46666C10.4336 6.27332 10.4336 5.95332 10.2402 5.75999C10.0469 5.56666 9.7269 5.56666 9.53357 5.75999L8.00023 7.29332L6.4669 5.75999C6.27357 5.56666 5.95357 5.56666 5.76023 5.75999C5.5669 5.95332 5.5669 6.27332 5.76023 6.46666L7.29357 7.99999L5.76023 9.53332C5.5669 9.72666 5.5669 10.0467 5.76023 10.24C5.86023 10.34 5.9869 10.3867 6.11357 10.3867C6.24023 10.3867 6.3669 10.34 6.4669 10.24L8.00023 8.70666L9.53357 10.24C9.63357 10.34 9.76023 10.3867 9.8869 10.3867C10.0136 10.3867 10.1402 10.34 10.2402 10.24C10.4336 10.0467 10.4336 9.72666 10.2402 9.53332L8.7069 7.99999Z'
      fill='#59637D'
    />
  </svg>
);
